// В.2.f-2: Проект «Обгоревший Феникс» (liv_proekt_obgorevshiy_feniks,
// legendary Действие).
// «Воскрешает юнитов из ОБОИХ сбросов в случайном порядке. Каждый юнит
//  появляется на случайной свободной ячейке (включая вражескую сторону).
//  Процесс продолжается пока ячейки не закончатся или сбросы не опустеют».
//
// Без picker'а.
//
// Алгоритм:
//   1. Собрать всех живых-бывших юнитов из обоих сбросов с пометкой
//      fromOwnerIdx (откуда взяли).
//   2. Перемешать через state.rng (Fisher-Yates).
//   3. Для каждой карты в перемешанном порядке:
//      a. Собрать все свободные ячейки на ОБЕИХ сторонах:
//         [{playerIdx, line, idx}].
//      b. Если свободных ячеек нет — break (поле забито).
//      c. Выбрать случайную ячейку через rng.int.
//      d. Если slot.playerIdx !== card.fromOwnerIdx — переместить карту
//         в стопку сброса игрока slot.playerIdx и обновить ownerId.
//      e. resurrectUnit(state, card, slot.playerIdx, {line, idx}).
//   4. Если оба сброса пусты ИЛИ поле заранее забито — Действие сгорает.
//
// Карта может попасть на сторону противника (xlsx-text это допускает).
// Контроль перейдёт к владельцу стороны куда попала.

import { resurrectUnit } from './resurrect.js';
import { registerImplementedAbility } from './warn-unimplemented.js';

export const CARD_ID = 'liv_proekt_obgorevshiy_feniks';
const LABEL = 'Обгоревший Феникс';

registerImplementedAbility(CARD_ID, 'oneshot');

export function actionTargets(_state, _playerIdx) {
  return [];
}

function collectCandidates(state) {
  const out = [];
  for (let idx = 0; idx < 2; idx++) {
    const p = state.players[idx];
    if (!p) continue;
    for (const c of p.discard) {
      if (c?.type === 'unit') out.push({ card: c, fromOwnerIdx: idx });
    }
  }
  return out;
}

function collectFreeSlots(state) {
  const out = [];
  for (let idx = 0; idx < 2; idx++) {
    const p = state.players[idx];
    if (!p) continue;
    for (let line = 0; line < 2; line++) {
      for (let slot = 0; slot < 4; slot++) {
        if (p.field[line][slot] === null) {
          out.push({ playerIdx: idx, line, idx: slot });
        }
      }
    }
  }
  return out;
}

export function resolve(state, playerIdx /*, target, opts */) {
  const me = state.players?.[playerIdx];
  const candidates = collectCandidates(state);
  if (candidates.length === 0) {
    state.log?.add(`🔁 ${LABEL}: оба сброса пусты — Действие сгорает`);
    return { ok: true, skipped: true };
  }
  const initialFree = collectFreeSlots(state);
  if (initialFree.length === 0) {
    state.log?.add(`🔁 ${LABEL}: поле забито — Действие сгорает`);
    return { ok: true, skipped: true };
  }
  // Перемешать кандидатов через rng (Fisher-Yates).
  const order = candidates.slice();
  for (let i = order.length - 1; i > 0; i--) {
    const j = state.rng.int(i + 1);
    [order[i], order[j]] = [order[j], order[i]];
  }
  let resurrected = 0;
  for (const { card, fromOwnerIdx } of order) {
    const free = collectFreeSlots(state);
    if (free.length === 0) break;
    const pick = free[state.rng.int(free.length)];
    // Если карта изначально в сбросе НЕ той стороны, куда воскрешаем —
    // переместим её и обновим ownerId.
    if (pick.playerIdx !== fromOwnerIdx) {
      const fromPlayer = state.players[fromOwnerIdx];
      const toPlayer = state.players[pick.playerIdx];
      const idxInDiscard = fromPlayer.discard.indexOf(card);
      if (idxInDiscard >= 0) fromPlayer.discard.splice(idxInDiscard, 1);
      toPlayer.discard.push(card);
      card.ownerId = pick.playerIdx;
    }
    const ok = resurrectUnit(state, card, pick.playerIdx, { line: pick.line, idx: pick.idx });
    if (ok) resurrected += 1;
  }
  state.log?.add(
    `🔁 ${LABEL} [${me?.name || '?'}]: воскрешено ${resurrected} юнит${pluralRu(resurrected)} ` +
    `(в т.ч. на стороне противника)`
  );
  return { ok: true };
}

function pluralRu(n) {
  const n10 = n % 10, n100 = n % 100;
  if (n10 === 1 && n100 !== 11) return 'а';
  if ([2, 3, 4].includes(n10) && ![12, 13, 14].includes(n100)) return 'ов';
  return 'ов';
}
